import { render, staticRenderFns } from "./LogsSystem.vue?vue&type=template&id=575adf32"
import script from "./LogsSystem.vue?vue&type=script&lang=js"
export * from "./LogsSystem.vue?vue&type=script&lang=js"
import style0 from "./LogsSystem.vue?vue&type=style&index=0&id=575adf32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports